import React, { useState, useEffect, lazy } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../../../middleware/authMiddleware';
import Sidebar from './sidebar';
import Navbar from './navbar';
import LoadingPage from '../../loader';

const Dashboard = lazy(() => import('../../../containers/admin/dashboard'));

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [collapsedSidebar, setCollapsedSidebar] = useState(false);
  const { isAuthenticated, loading, isAdmin } = useAuth();
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleCollapseSidebar = () => {
    setCollapsedSidebar(!collapsedSidebar);
  };

  // Responsive behavior
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setSidebarOpen(false);
        setCollapsedSidebar(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

//   if (!isAuthenticated) {
//     return <Navigate to="/admin/login" state={{ from: location }} replace />;
//   }

//   if (!isAdmin) {
//     return <Navigate to="/unauthorized" replace />;
//   }

  const isDashboardRoute = location.pathname === '/admin' || location.pathname === '/admin/';

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <div 
        className={`transition-all duration-300 ease-in-out ${
          sidebarOpen 
            ? collapsedSidebar 
              ? 'w-20' 
              : 'w-64' 
            : 'w-0'
        } fixed lg:relative z-30 h-full`}
      >
        <Sidebar 
          collapsed={collapsedSidebar} 
          toggleCollapse={toggleCollapseSidebar} 
        />
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && window.innerWidth < 1024 && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Main content */}
      <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 `}>
        <Navbar 
          toggleSidebar={toggleSidebar} 
          sidebarCollapsed={collapsedSidebar}
          toggleCollapseSidebar={toggleCollapseSidebar}
        />
        
        <main className="flex-1 overflow-y-auto p-4 md:p-6 ">
          <div className="container text-primary-base mx-auto">
            {isDashboardRoute ? (
              <Dashboard />
            ) : (
              <Outlet />
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;